var path = 'src/app/crud/list-remove-button.html';
var html = "<span ng-if=permission> <span ng-show=!item.isDeleted> <span ng-show=!clicked> <button ng-click=remove() ng-disabled=!removeEnabled type=button class=\"btn btn-xs btn-link\"><i class=\"fa fa-trash-o\"></i> Delete</button> </span> <span ng-show=clicked> <button ng-click=confirm() ng-disabled=!confirmEnabled type=button class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash-o\"></i> Delete</button> <button ng-click=cancel() type=button class=\"btn btn-xs btn-link\">Cancel</button> </span> </span> <span ng-show=item.isDeleted> <span class=\"btn btn-link\"><i class=\"fa fa-spinner fa-spin\"></i> Deleting</span> </span> </span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/crud/list-remove-button.html
 ** module id = 93
 ** module chunks = 0
 **/